import React from 'react';

import Thumb from '../img/air-cnc.png';
import Img from '../img/air-cnc2.png';

const AirCNC = {
    id: 104, permalink: "air-cnc", thumb: Thumb, title: "Air CNC", category: "React", categoryURL: "react", detailImg1: Thumb, detailImg2: Img, previewTxt: "Preview", previewURL: "https://air-cnc.web.app/", sourceTxt: "", sourceURL: "", description: <>
        <h3>Air CNC is a booking website.</h3>
        <p>&nbsp;</p>

        <h5>Main Featured:</h5>
        <ul>
            <li>Google Web Fonts Included.</li>
            <li>Dynamic Header.</li>
            <li>Search Terms.</li>
            <li>2 Step Data Filtration.</li>
        </ul>

        <h5>Technology Used:</h5>
        <ul>
            <li>React, JavaScript, Sass, Firebase, Google Analytics.</li>
        </ul>
    </>
};

export default AirCNC;